import { ApiResult, request, safeRequest } from '@synergy/api';
import { Canceler } from 'axios';
import { isMimeTypeImage } from '@synergy/utils';

import { PatchProductFileRequest } from './patch-product-file-request';
import { ProductFile } from '../../../../../../common/models/product-file';
import { ProductFiles } from '../models/product-files';

const getType = (mimeType: string): string => {
    if (isMimeTypeImage(mimeType)) {
        return 'image';
    }

    return 'document';
};

export class ProductDetailFilesApi {
    constructor(protected baseUrl: string) {}

    public getProductFiles(productId: number): Promise<ApiResult<ProductFiles>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/products/${productId}/media`),
            response => response.data
        );
    }

    public addProductFile(
        productId: number,
        file: File,
        cancelFunction?: (canceler: Canceler) => void,
        progressCallback?: (progress: ProgressEvent) => void
    ): Promise<ApiResult<ProductFiles>> {
        return safeRequest(
            () => {
                const data = new FormData();
                data.append('file', file, file.name);

                const config = {
                    headers: { 'content-type': 'multipart/form-data' },
                    onUploadProgress: progressCallback,
                    cancelToken: cancelFunction && new request.CancelToken(cancelFunction),
                };

                return request.post(`${this.baseUrl}/products/${productId}/media/${getType(file.type)}`, data, config);
            },
            response => response.data
        );
    }

    public patchProductFile(
        productId: number,
        fileId: number,
        mimeType: string,
        changes: PatchProductFileRequest
    ): Promise<ApiResult<ProductFile>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/products/${productId}/media/${getType(mimeType)}/${fileId}`, changes),
            response => response.data
        );
    }

    public deleteProductFile(productId: number, fileId: number, mimeType: string): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/products/${productId}/delete-media/${getType(mimeType)}/${fileId}`),
            response => response.data
        );
    }
}
